import qs from 'qs';

import axios from 'Services/axios';

import type { GetSellerCommunicationEnquiriesResult, Request } from './request';

type Query = Omit<Request['query'], 'enquiryIds'> & { enquiryIds?: number[] };
export type GetSellerCommunicationEnquiriesClientApiCall = (
	query?: Query,
) => Promise<GetSellerCommunicationEnquiriesResult>;

const getSellerCommunicationEnquiriesClientPath = (query?: Query) =>
	`/api/seller-communications/enquiries${qs.stringify(query, { addQueryPrefix: true, arrayFormat: 'repeat' })}`;

export const getSellerCommunicationEnquiries: GetSellerCommunicationEnquiriesClientApiCall = async (query) => {
	const res = await axios.get(getSellerCommunicationEnquiriesClientPath(query));
	return res.data as ReturnType<GetSellerCommunicationEnquiriesClientApiCall>;
};
